<template>
  <div style="width: 100%;height: 100%;">
    <div style="width: 100%;background-color: #fff;">
        <LayoutHeader />
      <div style="width: 100%;background-color: #fff;">
          <!-- <div class="banner-box">
              <img src="../assets/home/notice-banner.png" alt="">
              <div class="text">{{ $route.query.type == '1' ? '通知公告' : '政策公告'}}</div>
          </div> -->
          <div class="breadBox">
              <div class="child">
                  <a-breadcrumb>
          <span>
            当前位置：
          </span>
                      <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页</a-breadcrumb-item>
                      <a-breadcrumb-item  style="cursor: pointer;" @click="this.$router.push('/notice?type='+$route.query.type)">{{$route.query.type == '1' ? '通知公告' : '政策公告'}}</a-breadcrumb-item>
                  </a-breadcrumb>
              </div>

          </div>
        <div id="print" class="tabBox">
          <div class="title">{{ noticeObj.title || '' }}</div>
          <div class="subtitle">
              <span>编辑：<a href="https://www.yqgxqsc.com">www.yqgxqsc.com</a></span>
              <span> 发布日期：{{ noticeObj.publishTime && noticeObj.publishTime.split(' ')[0] || '' }}</span>
<!--            <span>编辑：<a href="https://www.yqgxqsc.com">www.yqgxqsc.com</a></span>-->
<!--            <span> 发布日期：{{ noticeObj.publishTime && noticeObj.publishTime.split(' ')[0] || '' }}</span>-->
<!--            <span onselectstart="return false;"> 字体: <span style="cursor: pointer;margin:0" @click="sizes++">【放大】</span><span-->
<!--                style="cursor: pointer;margin:0" @click="sizes&#45;&#45;">【缩小】</span><span style="cursor: pointer;margin:0"-->
<!--                @click="sizes = 16">【标准】</span>-->
<!--                <PrintOn></PrintOn>-->
<!--              </span>-->
          </div>
          <div class="titlecontent" :style="{ fontSize: sizes + 'px' }" v-html="noticeObj.contentAbstract || ''"></div>
          <div class="content" :style="{ fontSize: sizes + 'px' }" v-html="noticeObj.content || ''"></div>
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import { dictMixin } from "@/mixins";
import { login_mp } from "@/api/adminService";
import { ls } from "@/utils/util"
import { enterpriseOperatingIncome } from "@/api/integral";
import { sys_admin, file_service, sys_policyNotice } from "@/api/adminService";
import { noticeInfo, getBannerInfo, getWebInfo } from "@/api/homeService";
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import { getDistMixin, listMixin } from "@/mixins";

export default {
  name: "index",
  components: {
    LayoutFooter,
      LayoutHeader
  },
  mixins: [dictMixin, getDistMixin, listMixin],
  data() {
    return {
      sizes: 16,
      dictNames: 'policy_type',
      noticeData: [],
      fourObj: {},
      user: {},
      getDetailNoteParam: null,
      operatingIncomeScale: null,
      platformName,
      getAuditStatus: null,
      visible: false,
      getDateId: null,
      formState: {
        user: undefined,
      },
      noticeObj: {},
      bannerData: [],
      webSiteInfo: {},
      linkData: [],
      source: '',
      queryParam: {},
      listUrl: noticeInfo.pageList,
      current: 1,
      pageSize: 10,
      str: null
      // selectOption: [
      // 	{ label: '种子期(0（含）—100万元)', value: 1 },//seed
      // 	{ label: '初创期(100（含）—500万元)', value: 2 },//newly
      // 	{ label: '成长期(500（含）—2000万元)', value: 3 },//growth
      // 	{ label: '成熟期(2000（含）以上万元)', value: 4 }, //maturation
      // ],
    }
  },
  methods: {
    logout() {
      let self = this;

      self.$ls.clear();
      self.$store.commit('setMenuData', []);
      self.$router.replace('/');

      location.reload();
    },
    onLogout() {
      let self = this;
      self.$confirm({
        title: '确认要退出登录?',
        content: '',
        onOk() {
          self.postAction({
            url: login_mp.saveLog,
            params: { logAppCategoryEnum: "LOGOUT" }
          }).then(res => {
            console.log(res)
            self.getAction({
              url: login_mp.logout,
              params: { access_token: ls.get("token") || "" },
              isValid: false
            }).then(() => {
              self.$notification['success']({
                message: '退出成功',
                style: {
                  fontWeight: '600',
                },
              });
            })
          })


          setTimeout(() => {
            self.logout();
          }, 2000)
        },
        onCancel() {
        },
      });
    },
    goMorePolicy() {
      this.$router.push({
        path: '/notice',
        // query: { type: "资讯公告", activeKey: 2 }
      })
    },
    goDetail(id) {
      this.$router.push({
        path: "/noticeDetail",
        query: { id: id }
      })
    },
    getUserInfo() {
      this.getAction({
        url: sys_admin.userInfor
      }).then(res => {
        sessionStorage.setItem("roleCode", res.roleCode.split(','));
      })
    },
    goHttp(url) {
      window.open(url, '_bank')
    },
    goMore(url, str) {
      this.$router.push({ path: url, query: { id: str } })
    },
    goMoreNotice(url, str) {
      console.log('url: ', url, str)
      this.$router.push({ path: url, query: { ...str } })
    },
    getDetail() {
      if (this.$route.query.type == 1) {
        this.getAction({
          url: sys_policyNotice.detail,
          params: { id: this.$route.query.id }
        }).then(res => {
          this.noticeObj = res
            this.changeImageSrc(this.noticeObj)
        })
      } else {
        this.getAction({
          url: noticeInfo.noticeDetail,
          params: { id: this.$route.query.id }
        }).then(res => {
          this.noticeObj = res
            this.changeImageSrc(this.noticeObj)
        })
      }
    },
    getPolicyNotice() {
      this.getAction({
        url: sys_policyNotice.detail,
        params: { id: this.$route.query.id }
      }).then(res => {
        this.noticeObj = res
          this.changeImageSrc(this.noticeObj)
      })
    },
      changeImageSrc(noticeObj){
        if (noticeObj.content){
            noticeObj.content = noticeObj.content.replaceAll("http://114.115.237.125:8630/","https://www.yqgxqsc.com/")
            // noticeObj.content = noticeObj.content.replaceAll("download/","img?url=")
        }
      },
    goNoticeList() {
      if (this.$route.query.source == 'piao') {
        this.$router.push({
          path: '/notice',
          query: { source: 'piao' }
        })
      } else {
        this.$router.push({
          path: '/notice',
          query: { type: this.str }
        })
      }
    },
    getDate() {
      this.getAction({
        url: enterpriseOperatingIncome.getDate,
        // params: { id: id },
        returnMsg: true,
      }).then((res) => {
        this.getDateId = res.data
        // auditStatus
      });
    },
    islogin() {
      if (ls.get('token') && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else if (ls.get("roleCode").includes('serviceOrganization')) {
          this.goMore('/sys/innovation/organization/index');
        } else if (ls.get("roleCode").includes('investorManager')) {
          this.goMore('/finance/investorInformation');
        } else if (ls.get("roleCode").includes('investmentMechanism')) {
          this.goMore('/finance/investmentOrganizationInformation');
        } else if (ls.get("roleCode").includes('financialAdviser')) {
          this.goMore('/finance/financialAdvisorInformation');
        } else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
    getBannerList() {
      this.getAction({
        url: getBannerInfo.pageList,
        params: { type: 'home' }
      }).then(res => {
        this.bannerData = res.records.reverse()
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    getWebInfo() {
      this.getAction({
        url: getWebInfo.detail,
        params: { id: 1 }
      }).then(res => {
        this.webSiteInfo = res
      })
    },
  },
  mounted() {
    this.str = this.$route.query.type
    this.getWebInfo()
    this.getBannerList()
    // this.getDate()
    if (ls.get('token') && ls.get("refresh_token")) {
      this.user.userName = this.$ls.get('userName')
      this.user.phoneNumber = this.$ls.get('phoneNumber')
    }
    this.source = this.$route.query.source
    if (this.$route.query.source == 'piao') {
      this.getPolicyNotice()
    } else {
      this.getDetail()
    }
  }
}
</script>

<style scoped lang="less">

.headerBox {
  width: 100%;
  height: 92px;
  background-color: #fff;

  .hearderContentBox {
    width: 1200px;
    margin: 0 auto;

    .titleBox {
      cursor: pointer;
      overflow: hidden;
      float: left;
      line-height: 92px;
      font-size: 30px;
      font-weight: bold;

      .logoBox {
        float: left;
        width: 73px;
        height: 66px;
        margin-right: 5px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .rightBox {
      float: right;
      display: flex;
      justify-content: space-around;
      line-height: 92px;
      font-size: 16px;

      a {
        font-weight: 600;
      }

      .loginBox {
        // float: left;
        cursor: pointer;
      }

      .loginBox:hover {
        color: #fc550b;
      }

      .lineBox {
        height: 18px;
        top: 36px;
      }

      .resigierBox {
        cursor: pointer;
        // float: left;
      }

      .resigierBox:hover {
        color: #fc550b;
      }
    }
  }
}

.banner-box{
    position: relative;
    img{
        width: 100%;
        height: 240px;
        object-fit: cover;
    }
    .text{
        position: absolute;
        top: 60px;
        width: 1200px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        left:50%;
        transform: translateX(-50%);
        font-weight: 400;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 50px;
        &::before{
            content:'';
            display: block;
            width: 70px;
            height: 3px;
            background: #fff;
            position: absolute;
            top:60px;
        }
    }
}

.breadBox{
    width: 100%;
    border-bottom: 1px solid #DEDEDE;
    .child{
        width: 1200px;
        margin:0 auto;
        padding:20px 0;

    }
}

.tabBox {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0 20px 0;

  .title {
    text-align: center;
    font-size: 30px;
    color: #333;
  }

  .subtitle {
    font-size: 14px;
    margin-top: 20px;
    padding-bottom: 20px;
    color: #333;
    border-bottom: 1px solid #f3f3f3;
    display: flex;
    justify-content: center;

    span {
      margin: 0 20px;
        color:#999999;
        a{
            color:#999999;
        }
    }

    .gaishu {
      max-width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .titlecontent {
    text-align: center;
    font-size: 16px;
    //margin-top: 60px;
    font-weight: 600;
    padding: 0 10%;
    line-height: 40px;
  }

  .content {
    padding: 0 10%;
    font-size: 16px;
    line-height: 30px;
    margin-top: 30px;
    text-indent: 30px;

    :deep(img) {
      width: 60%;
      margin-left: 18%;
      margin-bottom: 20px;
    }

    :deep(p) {
      line-height: 40px;
    }
  }
}

.cardBox {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  height: auto;
  margin: 0 auto;
  // background-color: #fff;

  .smallCardBox {
    margin: 36px auto;
    height: 46px;

    .leftImg {
      float: left;
      width: 46px;
      height: 46px;
      border-radius: 50%;
    }

    .rightText {
      float: left;
      margin-left: 5px;
      line-height: 46px;

      span {
        font-size: 24px;
        color: #0048c4;
      }
    }
  }
}

.contentBox {
  margin: 0 auto 20px auto;
  width: 1200px;
  height: auto;

  .menuBox {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .smallMenuBox {
      position: relative;
      padding: 24px;
      width: 19%;
      // height: 180px;
      background-color: #fff;
      cursor: pointer;
      border: 1px solid #e1f1fe;

      .menuImg {
        position: absolute;
        bottom: 10px;
        right: 6px;
      }

      .menuTitle {
        margin-bottom: 22px;
        font-size: 20px;
        font-weight: bold;
      }

      .titleInfo {
        width: 90%;
        font-size: 14px;
        color: #666;
        z-index: 11;
        position: relative;
      }

      .showMoreBtn {
        margin-top: 15px;
        background-color: #fff;
        width: 44%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        opacity: 0;
      }
    }

    .smallMenuBox:hover {
      background-color: #0a2c83;
      color: #fff;
      border: none;
      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      //border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;

      .titleInfo {
        color: #fff;
      }

      .showMoreBtn {
        opacity: 1;
      }
    }
  }
}

.pointsBox {
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 55px 0;

  .recruitmentContentBox {
    padding: 14px 0;
    width: 100%;

    .moreList {
      float: right;
      margin-top: -21px;
      font-size: 14px;
      color: #999;
    }

    .moreList:hover {
      color: #0a2c83;
      cursor: pointer;
    }

    .listBox {
      position: relative;
      overflow: hidden;
      padding: 10px 0;
      cursor: pointer;
      border-bottom: 1px solid #dedede;

      .leftBox {
        float: left;
        width: 150px;
        height: 80px;
        text-align: center;
      }

      .right {
        float: left;
        margin-left: 2%;
        width: 74%;
        font-size: 14px;

        .title {
          padding: 10px 0;
          font-size: 20px;
          color: #333;
          font-weight: 500;
        }

        .content {
          overflow: hidden;
          margin: 10px 0;
          color: #666;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  .pagination {
    text-align: center;
    margin-bottom: 20px;
  }
}

.linkBig {
  width: 100%;
  background-color: #fff;

  .linkBox {
    overflow: hidden;
    font-size: 16px;
    color: #333;
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;


    .leftLabel {
      float: left;
      width: 7%;
      font-weight: bold;
    }

    .rightBox {
      float: left;
      margin-left: 15px;
      width: 90%;
      // display: flex;
      // justify-items: start;
      // flex-wrap: wrap;

      .itemLink {
        float: left;
        margin-right: 30px;
        margin-bottom: 5px;
        color: #333;
        // text-decoration: underline;
      }

      .itemLink:hover {
        color: #0a2c83;
      }
    }
  }
}

.footerBox {
  width: 100%;
  background-color: #333333;

  .footerContent {
    position: relative;
    margin: 0 auto;
    padding: 24px 0;
    width: 1200px;

    .firstLine {
      padding: 8px 0;
      font-size: 14px;
      color: #999;

      span {
        margin-right: 18px;
      }
    }

    .footCode {
      position: absolute;
      right: 0;
      bottom: 12%;
      text-align: center;

      .footEwm {
        margin-bottom: 8px;
      }

      .footEwmTitle {
        color: #999;
      }
    }
  }
}

:deep(.ant-list-lg .ant-list-item) {
  padding: 16px 8px;
}
</style>
